import React, { useState } from 'react'
import { ROUTE } from '../../route/Route'
import { Link, useLocation,useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { alreadyInCart } from '../../constant/utils';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';


const DetailBookButton = (props:any) => {
    const { t } = useTranslation();
    const {type, data,className}=props;
    const history=useHistory();
    const bookingData: any = useSelector((state: any) => (state.checkout.bookingData ? state.checkout.bookingData : {}));
    const handleCheckout = (e: any) => {
        e.preventDefault();
        const already = alreadyInCart(type, (type == "test" ? data?.TestCode : data?.PackageCode));
        if(!already){
            if(data?.SellingPrice === 0) {
                toast.error("Home collection is not available for this, please change your location");
            } else if(bookingData?.selectedMember?.gender && data?.Gender && data?.Gender != "both" && bookingData?.selectedMember?.gender?.toUpperCase() == data?.Gender?.toUpperCase()) {
                    toast.error(`You can not add this test, this test only for ${data?.Gender}`);
            } else if(data?.SellingPrice!==0){
                history.push(ROUTE.CHECKOUT, { type: type, data: data }); 
            }
        }
    }
    return (
        <a href={"#"} onClick={(e:any)=> handleCheckout(e)} className={className ? className :"button--hexagon normal active"}>
            <span>{t("book")} {"@"} &nbsp;&nbsp;&#x20B9;{`${data?.SellingPrice}`}<i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i></span>
        </a>
    )
}

export default DetailBookButton